const SourceIcon = ({ source }) => {
  const s = { width:12, height:12, viewBox:"0 0 24 24", fill:"none", stroke:"currentColor", strokeWidth:2, strokeLinecap:"round", strokeLinejoin:"round", flexShrink:0 };
  if (source === "Hemsidan")
    return <svg {...s}><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>;
  if (source === "Offerta.se" || source === "Servicefinder")
    return <svg {...s}><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>;
  if (source === "Hemnet")
    return <svg {...s}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>;
  if (source === "SMS")
    return <svg {...s}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>;
  if (source === "Rekommendation")
    return <svg {...s}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>;
  if (source === "Instagram")
    return <svg {...s}><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>;
  return null;
};

// Lead inbox — kanban-style with three columns
const LeadInbox = () => {
  const frameRef = React.useRef(null);
  const [animateIncoming, setAnimateIncoming] = React.useState(false);
  const cols = [
    { title: "Nya affärer", count: 8, color: "var(--ink-3)", leads: [
      {name:"Familjen Lindqvist", type:"Tillbyggnad · Lidingö", value:"420 000", sqm:"~23", source:"Offerta.se", age:"4 min"},
      {name:"BRF Solrosen", type:"Fasadrenovering · Danderyd", value:"580 000", sqm:"~150", source:"Hemsidan", age:"18 min"},
      {name:"Anders Berg", type:"Badrum · Bromma", value:"125 000", sqm:"~6", source:"Rekommendation", age:"1 tim"},
      {name:"Karin & Ola Nyström", type:"Köksrenovering · Nacka", value:"260 000", sqm:"~17", source:"SMS", age:"2 tim"},
    ]},
    { title: "Kontaktade", count: 5, color: "var(--accent-amber)", leads: [
      {name:"Sundberg Fastigh.", type:"Takbyte · 320 m²", value:"680 000", sqm:"~320", source:"Hemnet", age:"i går", followup:"Platsbesök tor 14:00"},
      {name:"Johan & Mia Ek", type:"Kök totalrenov.", value:"310 000", sqm:"~20", source:"Instagram", age:"2 dgr", followup:"Skicka offert"},
    ]},
    { title: "Offert skickad", count: 3, color: "var(--primary)", leads: [
      {name:"Villa Tegelbacken", type:"Altan + uterum", value:"245 000", sqm:"~30", source:"Servicefinder", age:"5 dgr", followup:"Påminnelse om 2 dgr", warm:true},
      {name:"Café Norrlyckan", type:"Lokalanpassning", value:"890 000", sqm:"~148", source:"SMS", age:"1 vecka"},
    ]},
  ];

  React.useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return;

    if (!("IntersectionObserver" in window)) {
      setAnimateIncoming(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimateIncoming(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(frame);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={frameRef} className={`screen-frame ${animateIncoming ? "animate-incoming" : ""}`} data-label="Lead inbox">
      <ScreenChrome title="Inkommande affärer" />
      <div className="screen-body">
        <div className="intake-bar">
          <span style={{fontSize:10.5, fontFamily:'var(--font-mono)', color:'var(--ink-3)', textTransform:'uppercase', letterSpacing:'0.1em', flexShrink:0, fontWeight:600}}>Lägg till via</span>
          <div className="intake-actions">
            <button className="intake-btn intake-btn-ai">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>
              AI-tolkning
            </button>
            <button className="intake-btn">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 1 3 3v7a3 3 0 0 1-6 0V5a3 3 0 0 1 3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="22"/></svg>
              Röstmemo
            </button>
            <button className="intake-btn">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
              SMS
            </button>
            <div className="intake-divider"/>
            <button className="intake-btn intake-btn-connect">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
              Anslut <span style={{opacity:0.55, fontWeight:400}}>t.ex. Offerta.se</span>
            </button>
          </div>
        </div>
        <div className="kanban">
          {cols.map((col, colIdx) => {
            const isIncoming = col.title === "Nya affärer";

            return (
              <div key={col.title} className={`kanban-col ${isIncoming ? "incoming-col" : ""}`}>
                <div className="kanban-head">
                  <span style={{display:'flex', alignItems:'center', gap:8}}>
                    <span className="kanban-dot" style={{background:col.color}}/>
                    <span style={{fontWeight:600, fontSize:13}}>{col.title}</span>
                    <span className="mono" style={{color:'var(--ink-4)', fontSize:12}}>{col.count}</span>
                  </span>
                  <span style={{color:'var(--ink-4)', fontSize:14}}>⋯</span>
                </div>
                <div className="kanban-cards">
                  {col.leads.map((l, i) => (
                    <div key={i} className={`lead-card ${isIncoming ? 'incoming-lead' : 'other-lead'} ${l.hot ? 'hot' : ''} ${l.warm ? 'warm' : ''}`} style={isIncoming ? {"--incoming-index": i} : {"--other-delay": `${1.4 + colIdx * 0.2 + i * 0.25}s`}}>
                      <div className="lead-meta">
                        {isIncoming && <span className="new-tag">NY</span>}
                        <span className="lead-source"><span style={{fontWeight:400, color:'var(--ink-4)'}}>via</span> <span style={{color:'var(--primary)', display:'inline-flex', alignItems:'center', gap:4}}><SourceIcon source={l.source}/>{l.source}</span></span>
                      </div>
                      <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:4, gap:8}}>
                        <div className="lead-name" style={{fontWeight:600, fontSize:13.5}}>{l.type}</div>
                        {l.hot && <span className="hot-tag" style={{flexShrink:0}}>HOT</span>}
                      </div>
                      <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:5}}>
                        <div className="mono" style={{fontSize:12.5, color:'var(--ink-3)', fontWeight:500}}>~ {l.value} kr</div>
                        {l.sqm && <div className="mono" style={{fontSize:11, color:'var(--ink-4)'}}>{l.sqm} kvm</div>}
                      </div>
                      {l.followup && (
                        <div className="followup followup-animate">
                          <span style={{color:'var(--accent-amber)'}}>●</span> {l.followup}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const ScreenChrome = ({title}) => (
  <div className="screen-chrome">
    <div className="screen-main">
      <div className="screen-topbar">
        <div style={{minWidth:0, flex:1}}>
          <div className="crumb" style={{fontSize:11, fontFamily:'var(--font-mono)', color:'var(--ink-4)', textTransform:'uppercase', letterSpacing:'0.08em'}}>Arbetsyta / {title}</div>
          <div style={{fontWeight:600, fontSize:18, marginTop:2, letterSpacing:'-0.01em', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{title}</div>
        </div>
        <div style={{display:'flex', gap:8, alignItems:'center'}}>
          <div className="avatar">EJ</div>
        </div>
      </div>
    </div>
  </div>
);

Object.assign(window, { LeadInbox, ScreenChrome });
